"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AuthLayout", {
  enumerable: true,
  get: function get() {
    return _AuthLayout["default"];
  }
});
var _AuthLayout = _interopRequireDefault(require("./AuthLayout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }